import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, CrownIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-warm-brown text-cream py-16 border-t border-brand-gold/20" data-id="element-133">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-135">
          {/* Logo + Tagline */}
          <div className="flex flex-col items-start gap-4" data-id="element-136">
            <div className="flex items-center gap-2" data-id="element-137">
              <CrownIcon className="w-8 h-8 text-brand-gold" data-id="element-138" />
              <span className="font-display italic text-4xl lowercase tracking-wider text-cream" data-id="element-139">
                rozii
              </span>
            </div>
            <span className="font-body text-xs uppercase tracking-[0.2em] text-brand-gold font-bold" data-id="element-140">
              African Hair Braiding
            </span>
            <p className="text-sm text-cream/70 font-display italic mt-2 text-lg" data-id="element-141">
              Crown every woman.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-142">
            <h4 className="font-display text-2xl text-brand-gold mb-6" data-id="element-143">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-4" data-id="element-144">
              <Link to="/" className="text-sm uppercase tracking-widest hover:text-brand-gold transition-colors" data-id="element-145">
                Home
              </Link>
              <Link to="/services" className="text-sm uppercase tracking-widest hover:text-brand-gold transition-colors" data-id="element-146">
                Services
              </Link>
              <Link to="/about" className="text-sm uppercase tracking-widest hover:text-brand-gold transition-colors" data-id="element-147">
                About
              </Link>
              <Link to="/gallery" className="text-sm uppercase tracking-widest hover:text-brand-gold transition-colors" data-id="element-148">
                Gallery
              </Link>
              <Link to="/contact" className="text-sm uppercase tracking-widest hover:text-brand-gold transition-colors" data-id="element-149">
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div data-id="element-150">
            <h4 className="font-display text-2xl text-brand-gold mb-6" data-id="element-151">
              Contact Info
            </h4>
            <div className="flex flex-col gap-4 text-sm tracking-wide text-cream/80" data-id="element-152">
              <a href="tel:2409217857" className="hover:text-brand-gold transition-colors font-bold text-cream" data-id="element-153">
                (240) 921-7857
              </a>
              <p data-id="element-154">
                7375 Executive Place
                <br data-id="element-155" />
                Suite 214, Lanham MD
              </p>
              <p className="text-brand-gold font-bold mt-2" data-id="element-156">
                $25 Deposit Policy
              </p>
            </div>
          </div>

          {/* Follow Us */}
          <div data-id="element-157">
            <h4 className="font-display text-2xl text-brand-gold mb-6" data-id="element-158">
              Follow Us
            </h4>
            <div className="flex items-center gap-4" data-id="element-159">
              <a href="https://www.instagram.com/roziiepse/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-cream/10 flex items-center justify-center text-cream hover:bg-brand-gold hover:text-warm-brown transition-colors" aria-label="Instagram" data-id="element-160">
                <InstagramIcon className="w-6 h-6" data-id="element-161" />
              </a>
              <a href="https://www.tiktok.com/@roziiepse1.11" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-cream/10 flex items-center justify-center text-cream hover:bg-brand-gold hover:text-warm-brown transition-colors" aria-label="TikTok" data-id="element-162">
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-163">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.71a8.21 8.21 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.14z" data-id="element-164" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/10 text-center" data-id="element-165">
          <p className="text-sm text-cream/60 font-body" data-id="element-166">
            &copy; {new Date().getFullYear()} Rozii African Hair Braiding. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}